module.exports = __webpack_public_path__ + "static/media/48489D05-5601-47AC-995C-36415EE649BD.2bcf3c1f.bin";